import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      pages: 'page/pages',
      includeInFooterRow1: 'page/includeInFooterRow1',
      includeInFooterRow2: 'page/includeInFooterRow2',
      includeInFooterRow3: 'page/includeInFooterRow3',
      includeInSitemap: 'page/includeInSitemap',
      includeInTopMenu: 'page/includeInTopMenu',
    }),
  },
  methods: {
    ...mapActions({
      fetchPages: 'page/fetchPages',
    }),
  },
};
